<svg
  role="img"
  [ngClass]="cssClasses"
  [attr.aria-label]="label || 'icon'"
  [attr.height]="iconDimensions[size]"
  [attr.width]="iconDimensions[size]"
>
  <use [attr.xlink:href]="iconUrl"></use>
</svg>
